<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="page-content">
      <div class="discovery-create-container">
        <div class="head">
          <div class="cancel" @click="back">取消</div>
          <div class="submit" @click="submit">发布</div>
        </div>
        <div class="body">
          <Field
            class="value"
            v-model="form.value"
            rows="10"
            type="textarea"
            placeholder="发表你精彩的文案…"
          />
          <div class="images">
            <Uploader
              v-model="form.images"
              :after-read="afterRead"
              :max-count="9"
              right-icon="arrow"
            >
            </Uploader>
          </div>
        </div>
        <div class="good">
          <div class="good-wrapper" v-if="form.goods">
            <div class="head-tit">所关联商品</div>
            <div class="good-content" @click="toGoods">
              <div
                class="img"
                :style="{
                  backgroundImage: 'url(' + form.goods.goodsInfoImg + ')',
                }"
              ></div>
              <div class="content">
                <div class="tit van-ellipsis">
                  {{ form.goods.goodsInfoName }}
                </div>
                <div class="amount">
                  <span class="prefix">¥</span>
                  <span class="value">{{ form.goods.actPrice }}</span>
                  <span class="reward">省赚¥</span>
                  <span class="reward-value">
                    {{ form.goods.saveProfit || 0 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="btn" @click="toGoods" v-else>选择关联商品</div>
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import Bus from '@/utils/bus'
import Compressor from 'compressorjs'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import { Field, Uploader, Toast } from 'vant'
import { uploadImage } from '@/api/index'
import { createMaterial } from '@/api/discovery'

export default {
  components: { CustomPage, CustomView, Field, Uploader },
  data() {
    return {
      form: {
        value: '',
        images: [],
        goods: null,
      },
    }
  },
  created() {
    Bus.$on('selectDiscoveryCreateGoods', this.selectGoods)
  },
  methods: {
    submit() {
      if (!this.form.value) {
        return Toast.fail('请输入文案')
      }
      if (!this.form.images.length) {
        return Toast.fail('请上传图片')
      }
      if (!this.form.goods) {
        return Toast.fail('请关联商品')
      }

      this.$store.dispatch('app/showLoading')
      const params = {
        content: this.form.value,
        urls: this.form.images.map((item) => item.url),
        goodsId: this.form.goods.spuId,
        goodsInfoNo: this.form.goods.goodsInfoNo,
        actId: this.form.goods.actId,
        goodsName: this.form.goods.goodsInfoName,
        skuId: this.form.goods.skuId,
        actPrice: this.form.goods.actPrice,
        saveProfit: this.form.goods.saveProfit,
        actName: this.form.goods.actName,
        goodsImage: this.form.goods.goodsInfoImg,
      }
      createMaterial(params)
        .then((res) => {
          Toast.success('发布成功')
          Bus.$emit('discoveryRefreshData')
          this.$store.dispatch('app/hideLoading')
          this.back()
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    back() {
      this.$router.back()
    },
    afterRead(file) {
      new Compressor(file.file, {
        quality: 0.6,
        success: async (result) => {
          file.status = 'uploading'
          file.message = '上传中...'
          try {
            const imgUrl = await this.uploadAvatar(result)
            file.url = imgUrl
          } catch (error) {
            file.status = 'failed'
            file.message = '上传失败'
          }
          file.status = ''
          file.message = ''
        },
      })
    },
    uploadAvatar(file) {
      return new Promise((resolve, reject) => {
        const params = new FormData()
        params.append('file', file)
        uploadImage(params)
          .then((res) => {
            resolve(res.data)
          })
          .catch(reject)
      })
    },
    toGoods() {
      this.$router.push({ name: 'DiscoveryCreateGoods' })
    },
    selectGoods(data) {
      this.form.goods = data
      // {
      //   goodsId: this.source.spuId,
      //   goodsInfoNo: this.source.goodsInfoNo,
      //   actId: this.source.actId,
      //   goodsName: this.source.goodsInfoName,
      // }
    },
  },
}
</script>

<style lang="less" scoped>
.page-content {
  height: 100%;
}
.discovery-create-container {
  display: flex;
  flex-direction: column;
  align-content: space-between;
  height: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    .cancel {
      font-size: 28px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      padding: 30px 20px;
    }
    .submit {
      font-size: 28px;
      font-weight: 600;
      color: #e82035;
      line-height: 28px;
      padding: 30px 20px;
    }
  }
  .body {
    flex: 1;
    min-height: 0;
    overflow: auto;
    .value {
      font-size: 28px;
      font-weight: 400;
      color: #333;
      line-height: 1.5em;
      padding: 20px 40px;
      &::after {
        display: none;
      }
    }
    .images {
      padding: 0 20px 20px;
      .image {
        width: 120px;
        height: 120px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }
  .good {
    padding: 20px;
    .good-wrapper {
      .head-tit {
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        padding-bottom: 20px;
      }
      .good-content {
        display: flex;
        background: #f5f5f5;
        border-radius: 16px;
        padding: 20px;
        .img {
          width: 80px;
          height: 80px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
        }
        .content {
          flex: 1;
          min-width: 0;
          padding-left: 20px;
          .tit {
            font-size: 24px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
          }
          .amount {
            margin-top: 12px;
            display: flex;
            align-items: flex-end;
            .prefix {
              display: block;
              font-size: 24px;
              line-height: 28px;
              font-weight: 800;
              color: #333333;
            }
            .value {
              display: block;
              font-size: 32px;
              line-height: 32px;
              font-weight: 800;
              color: #333333;
            }
            .reward {
              font-size: 20px;
              line-height: 24px;
              color: #e82035;
              font-weight: 600;
              margin-left: 8px;
            }
            .reward-value {
              font-size: 20px;
              font-weight: 600;
              color: #e82035;
              line-height: 24px;
            }
          }
        }
      }
    }
    .btn {
      padding: 45px 0;
      width: 100%;
      text-align: center;
      background: #f5f5f5;
      border-radius: 16px;
      font-size: 28px;
      font-weight: 400;
      color: #808080;
      line-height: 28px;
    }
  }
}
</style>
<style lang="less">
.discovery-create-container .body .images {
  .van-uploader {
    width: 100%;
    .van-uploader__wrapper > div[class^='van-uploader__'] {
      width: 32%;
      margin-right: 2%;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &.van-uploader__upload {
        position: relative;
        padding-top: 32%;
        .van-uploader__upload-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-uploader__preview-image {
        position: relative;
        width: 100%;
        padding-top: 100%;
        img {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .van-uploader__preview-delete {
        width: 35px;
        height: 35px;
        border-radius: 0 0 0 30px;
        .van-uploader__preview-delete-icon {
          top: -3px;
          right: -3px;
          font-size: 38px;
        }
      }
    }
  }
}
</style>